import Home from "./pages/homepage/Home";
import Profile from "./pages/profile/Profile";


function App() {
  return (
    <div>
      <Profile />
    </div>
  );
}

export default App;
